import type { SpecieTaxonTreeResource } from "@carnet/api/backoffice";

// L'API renvoie des ids numériques ; on les normalise en chaîne pour comparer avec les valeurs
// de filtre (toujours stockées en chaîne, côté URL web comme côté état mobile).
export function normalizeTaxonIds(node: SpecieTaxonTreeResource): SpecieTaxonTreeResource {
  return { ...node, id: String(node.id), children: node.children.map(normalizeTaxonIds) };
}

export function flattenTaxons(nodes: SpecieTaxonTreeResource[]): SpecieTaxonTreeResource[] {
  const out: SpecieTaxonTreeResource[] = [];
  for (const node of nodes) {
    out.push(node);
    out.push(...flattenTaxons(node.children));
  }
  return out;
}

// id → libellé, pour afficher le libellé d'un taxon sélectionné (chips).
export function buildTaxonLabelMap(roots: SpecieTaxonTreeResource[]): Record<string, string> {
  const map: Record<string, string> = {};
  for (const node of flattenTaxons(roots)) map[node.id] = node.name;
  return map;
}
